export const getMPEmail = async (mpId: string): Promise<string | null> => {
  const url = `https://members-api.parliament.uk/api/Members/${mpId}/Contact`;
  const headers = {
    "Content-Type": "application/json",
  };
  const options = {
    method: "GET",
    headers,
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) return null;

    const result = await response.json();
    const contacts = result?.value;
    if (!Array.isArray(contacts)) return null;

    // Prefer parliamentary email, fall back to public, then first available
    let publicEmail: string | null = null;
    let fallbackEmail: string | null = null;

    for (const contact of contacts) {
      const type = (contact?.type ?? "").toLowerCase();
      const email = contact?.email ?? null;
      if (!email) continue;

      if (type === "parliamentary" || type === "parliamentary email") {
        return email; // Best match — return immediately
      }
      if ((type === "public" || type === "public email") && !publicEmail) {
        publicEmail = email;
      }
      if (!fallbackEmail) {
        fallbackEmail = email;
      }
    }

    return publicEmail ?? fallbackEmail ?? null;
  } catch {
    return null;
  }
};
